"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _choiceActions = require("../actions/choiceActions");
var _settings = require("../settings");
function Option(_ref) {
  var option = _ref.option,
    onChoiceSelected = _ref.onChoiceSelected,
    onChoicesSelected = _ref.onChoicesSelected;
  if (!option) {
    return null;
  }
  var _getSettings = (0, _settings.getSettings)(),
    templates = _getSettings.templates;
  var Template = templates[option.presentationName];
  if (option.isHidden || option.isDisabled || !option.isActive) {
    return null;
  }
  if (!Template) {
    // eslint-disable-next-line no-console
    console.error("Missing template for presentation type ".concat(option.presentationName));
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(Template, {
    option: option,
    onChoiceSelected: onChoiceSelected,
    onChoicesSelected: onChoicesSelected
  });
}
Option.propTypes = {
  option: _propTypes["default"].shape({
    presentationName: _propTypes["default"].string.isRequired,
    id: _propTypes["default"].number.isRequired,
    isHidden: _propTypes["default"].bool,
    isDisabled: _propTypes["default"].bool,
    isActive: _propTypes["default"].bool
  }).isRequired,
  onChoiceSelected: _propTypes["default"].func.isRequired,
  onChoicesSelected: _propTypes["default"].func.isRequired
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onChoiceSelected: function onChoiceSelected(optionId, choiceId, choiceValue, activatesPromo) {
      return dispatch((0, _choiceActions.updateChoice)(optionId, choiceId, choiceValue, activatesPromo));
    },
    onChoicesSelected: function onChoicesSelected(choices) {
      return dispatch((0, _choiceActions.updateChoices)(choices));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(undefined, mapDispatchToProps)(Option);
//# sourceMappingURL=Option.js.map